import { Check, ArrowUpRight } from "lucide-react";
import { STARTER_KIT_URL } from "@/lib/translations";
import { trackEvent } from "@/lib/analytics";

const KIT_IMG = "/hero/starter-kit-flowers.png";

export default function StarterKitSection({ t }) {
  return (
    <section
      id="starter-kit"
      data-testid="starter-kit-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Image — left, overlapping dark block */}
        <div className="lg:col-span-6 relative">
          <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#2c4a3b] rounded-3xl -z-10" />
          <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-[#bc6c25]/15 rounded-3xl -z-10" />
          <img
            src={KIT_IMG}
            alt="Immunotec Starter Kit"
            className="w-full h-[420px] md:h-[560px] object-cover rounded-3xl shadow-[0_30px_80px_-30px_rgba(44,74,59,0.45)]"
            loading="lazy"
          />
        </div>

        {/* Content — right */}
        <div className="lg:col-span-6">
          <p className="text-overline">{t.starter.overline}</p>
          <h2
            className="font-serif font-light tracking-tight leading-[1.05] text-4xl md:text-5xl mt-5 text-[#1a2421]"
            data-testid="starter-kit-title"
          >
            {t.starter.title}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[#5c6b61] max-w-xl">
            {t.starter.body}
          </p>

          <ul className="mt-10 space-y-4">
            {t.starter.bullets.map((b, i) => (
              <li
                key={i}
                className="flex items-start gap-4"
                data-testid={`starter-bullet-${i}`}
              >
                <span className="mt-0.5 w-7 h-7 rounded-full bg-[#2c4a3b]/10 grid place-items-center shrink-0">
                  <Check className="w-4 h-4 text-[#2c4a3b]" />
                </span>
                <span className="text-[#1a2421] leading-relaxed">{b}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-4">
            <a
              href={STARTER_KIT_URL}
              target={STARTER_KIT_URL.startsWith("http") ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid="buy-starter-kit-btn"
              onClick={() => trackEvent("starter_kit_click", { event_category: "conversion", source: "starter_kit_section" })}
              className="group inline-flex items-center gap-3 rounded-full bg-[#bc6c25] hover:bg-[#9c581e] text-white px-8 py-4 text-sm font-semibold tracking-wide transition-all lift"
            >
              {t.starter.cta}
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
            </a>
            <span className="text-xs text-[#5c6b61] max-w-xs">
              {t.starter.note}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
